<template>
  <div class="sub-wrap">
    <search @onSearch='onSearch' @onSearchAll='onSearchAll' @refreshData='refreshData' :todayDate='todayDate' :isSubscriber='true' />
    <p class="sub-length-info">
      <span>현재 예약자 인원</span> {{subscribeInfo.length}}명
    </p>
    <div class="table-wrap">
      <div class="thead">
        <div class="tr">
          <span class="th">이름</span>
          <span class="th">고객번호</span>
          <span class="th">S/A</span>
          <span class="th">검진항목</span>
          <span class="th">메모</span>
        </div>
      </div>
      <img src="/static/Rolling.svg" alt="loading" v-if="isLoading">
      <div class="tbody-wrap" v-else>
        <div class="tbody" v-if="subscribeInfo">
          <div class="tr" v-for="(info, index) in subscribeInfo" :key="index">
            <span class="td">
              <div class="flex-wrap">
                <span>
                  {{info.pat_nm}}
                </span>
              </div>
            </span>
            <span class="td">
              <div class="flex-wrap">
                <span>
                  {{info.chart_num}}
                </span>
              </div>
            </span>
            <span class="td">
              <div class="flex-wrap">
                <span>{{info.pat_gen_age}}</span>
              </div>
            </span>
            <span class="td">
              <div class="flex-wrap">
                <span>{{info.check_item}}</span>
              </div>
            </span>
            <span class="td">
              <div class="flex-wrap">
                <span>
                  {{info.memo}}
                </span>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Search from './common/Search'
import dayJs from 'dayjs'
export default {
  components: {
    'search': Search
  },
  data () {
    return {
      subscribeInfo: [],
      todayDate: dayJs().format('YYYY-MM-DD'),
      isLoading: true
    }
  },
  created () {
    this.$http.get('/DID_API/reserve_patient.php', {
      params: {
        pat_nm: '',
        date: this.todayDate,
        chart_num: ''
      }
    }).then(result => {
      this.subscribeInfo = result.data.data
      this.isLoading = false
    })
      .catch(() => {
        alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
        this.isLoading = false
      })
  },
  methods: {
    // 조회 버튼 누를시 처리
    onSearch (name, chartNum, date) {
      this.isLoading = true
      this.$http.get('/DID_API/reserve_patient.php', {
        params: {
          pat_nm: name,
          date: date,
          chart_num: chartNum
        }
      }).then(result => {
        this.subscribeInfo = result.data.data
        this.isLoading = false
      })
        .catch(() => {
          alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
          this.isLoading = false
        })
    },
    // 전체조회 버튼 누를시 처리
    onSearchAll (date) {
      this.isLoading = true
      this.$http.get('/DID_API/reserve_patient.php', {
        params: {
          pat_nm: '',
          date: date,
          chart_num: ''
        }
      }).then(result => {
        this.subscribeInfo = result.data.data
        this.isLoading = false
      })
        .catch(() => {
          alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
          this.isLoading = false
        })
    },
    refreshData (date) {
      this.isLoading = true
      this.$http.get('/DID_API/reserve_patient.php', {
        params: {
          pat_nm: '',
          date: date,
          chart_num: ''
        }
      }).then(result => {
        this.subscribeInfo = result.data.data
        this.isLoading = false
      })
        .catch(() => {
          alert('서버에 연결할 수 없습니다.네트워크 연결 상태를 확인하시고 다시 접속을 시도해 주십시오')
          this.isLoading = false
        })
    },
    returnBrText (data) {
      return data.slice(0, 9) + '<br/>' + data.slice(10)
    }
  }
}
</script>

<style scoped lang='scss'>
@import './common/table';
.sub-length-info {
  position: absolute;
  top: 100px;
  right: 3vw;
  span {
    margin-right: 10px;
  }
}
.sub-wrap {
  img[alt='loading'] {
    display: block;
    position: absolute;
    width: 80px;
    height: 80px;
    left: 50%;
    margin-left: -40px;
    top: 50%;
    margin-top: -40px;
  }
  .tbody-wrap {
    height: 92%;
  }
  .table-wrap {
    width: 85.5vw;
    position: absolute;
    right: 1.5vw;
    height: 82vh;
    background-color: white;
    .thead .tr {
      height: 6vh;
      line-height: 6vh;
      .th {
        &:first-child {
          width: 10vw;
        }
        &:nth-child(2) {
          width: 15vw;
        }
        &:nth-child(3) {
          width: 10vw;
        }
        &:nth-child(4) {
          width: 24vw;
        }
        &:nth-child(5) {
          width: 24vw;
        }
      }
    }
    .tbody .tr {
      height: 7.4vh;
      // line-height: 3.6vh;
      .td {
        height: 100%;
        > .flex-wrap {
          display: -webkit-box;
          display: -moz-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          height: 100%;
          align-items: center;
          justify-content: center;
        }
        &:first-child {
          width: 10vw;
          > .flex-wrap span {
            max-width: 100%;
          }
        }
        &:nth-child(2) {
          width: 15vw;
          > .flex-wrap span {
            max-width: 100%;
          }
        }
        &:nth-child(3) {
          width: 10vw;
        }
        &:nth-child(4),
        &:nth-child(5) {
          word-break: break-all;
          white-space: normal;
          overflow: initial;
          overflow-y: auto;
          width: 24vw;
          > .flex-wrap > span {
            line-height: 3.5vh;
            margin: auto 0;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1500px) {
  .sub-wrap .table-wrap {
    .thead .tr .th:nth-child(4) {
      width: 22vw;
    }
    .tbody .tr .td:nth-child(4) {
      width: 22vw;
    }
  }
}
@media screen and (min-width: 1300px) and (max-width: 1499px) {
  .sub-wrap .table-wrap {
    height: 86vh;
  }
}
@media screen and (max-height: 610px) {
  .sub-wrap .table-wrap {
    height: 77vh;
    .tbody .tr .td {
      &:nth-child(4),
      &:nth-child(5) {
        > .flex-wrap > span {
          line-height: 5vh;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SubscriberSearch.vue